module.exports = __webpack_public_path__ + "img/icon-gift.328a177a.svg";